import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import Dialog, { ButtonType } from '@/components/Dialog.vue';
import * as Locale from '@/plugins/i18n';
import { platform } from '@/common/bridge';

interface Props {
  buttons?: ButtonType[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VoiceDisclaimer',
  props: {
    buttons: { default: () => [] }
  },
  setup(__props: any) {



const showDisclaimer = computed(() => {
  return platform !== 'web';
});

return { __sfc: true,showDisclaimer, Dialog, Locale }
}

})